/** Central topic registry — drives the hub cards and prev/next nav. */

export interface LearnTopic {
  slug: string;
  title: string;
  topicTag: string;
  blurb: string;
  readTime: string;
}

export const TOPICS: LearnTopic[] = [
  {
    slug: 'paper-vs-live',
    title: 'Paper vs Live Trading',
    topicTag: 'Start Here',
    blurb:
      "Why every new account starts in paper mode, what's different about live, and when you're ready to flip the switch.",
    readTime: '4 min read',
  },
  {
    slug: 'ai-screener',
    title: 'How the AI Screener Works',
    topicTag: 'The Product',
    blurb:
      'Claude + GPT look at the same setup and only agree when it meets the bar. Here is what that consensus means and what it does not.',
    readTime: '5 min read',
  },
  {
    slug: 'reading-signals',
    title: 'Reading a Signal in Context',
    topicTag: 'Core Concepts',
    blurb:
      "An RSI of 5 on AAPL is a totally different trade at 10:30 than at 12:30. Here's how to read indicator + regime + session + short interest together.",
    readTime: '6 min read',
  },
  {
    slug: 'calibration',
    title: 'The Calibration Dashboard',
    topicTag: 'Trust Signal',
    blurb:
      "Every AI call is scored against what actually happened. Here's how to read your win-rate-by-confidence-bucket — and why it matters.",
    readTime: '5 min read',
  },
];

export function findTopic(slug: string): LearnTopic | undefined {
  return TOPICS.find((t) => t.slug === slug);
}

export function neighbors(slug: string): { prev?: LearnTopic; next?: LearnTopic } {
  const idx = TOPICS.findIndex((t) => t.slug === slug);
  if (idx < 0) return {};
  return {
    prev: idx > 0 ? TOPICS[idx - 1] : undefined,
    next: idx < TOPICS.length - 1 ? TOPICS[idx + 1] : undefined,
  };
}
